import { render, staticRenderFns } from "./ArtworkItem.vue?vue&type=template&id=52c3c8a0&"
import script from "./ArtworkItem.vue?vue&type=script&lang=js&"
export * from "./ArtworkItem.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports